import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class AudioRecordingsPaths {
  static audioRecordings = new EnhancedPath('/audio-recordings');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: AudioRecordingsPaths.audioRecordings.path,
      component: lazyWithRetry(() => import('app/pages/system/audioRecordings')),
      pageCode: PAGE_CODES.AUDIO_RECORDINGS,
    },
  ],
};

export default routesConfig;
